<template>
	<div class="overlay-dialog">
		<h2 class="overlay-dialog__title" v-html="$t('cart.locationEdit.title')"/>
		<div class="overlay-dialog__text">
			<p v-html="$t('cart.locationEdit.text')"/>
		</div>

		<div class="overlay-dialog__buttons">
			<Button
				@click.prevent="$emit('cancel')"
				level="tertiary"
				type="button"
				:text="$t('cart.locationEdit.cancelButton')"
				arrow
				reverse
			/>
			<Button
				@click.prevent="$emit('confirm')"
				level="primary"
				type="button"
				:text="$t('cart.locationEdit.acceptButton')"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Button from '@/components/Button'

export default {
	mixins: [

		],
	components: {
		Button,
	},
	props: {
	},
	data() {
		return {
		}
	},
	computed: {
	},
	methods: {
	}
}
</script>

<style>

</style>